// extracted by mini-css-extract-plugin
export default {"modalTitle":"SwapModal_modalTitle__xLMxX","detailText":"SwapModal_detailText__9k+wj","inputError":"SwapModal_inputError__FjPdO"};